import { Directive } from "@angular/core";

@Directive({
  selector: "[stop-propagation]",
  host: {
    "(click)": "click($event)",
  },
  standalone: true,
})
export class StopPropagationDirective {
  click(event: Event): void {
    event.stopPropagation();
  }
}
